export interface User {
  username: string;
  firstname: string;
  lastname: string;
  email: string;
}

export function isPremiumUserPlan(userPlan: UserPlan): userPlan is PremiumUserPlan {
  return userPlan.isPremium;
}

export interface PremiumUserPlan {
  isPremium: true;
  isCancellable: boolean;
  productName: string;
  currentPeriodEnd: string;
}

export type UserPlan = PremiumUserPlan | { isPremium: false };

export enum MessageType {
  OngoingOffer = 'OngoingOffer',
  ExpiredFreeTrial = 'ExpiredFreeTrial',
  ExpiredPass = 'ExpiredPass',
  ExpiredSubscription = 'ExpiredSubscription',
  NoOffer = 'NoOffer',
}

export enum ModalType {
  OngoingFreeTrial = 'OngoingFreeTrial',
  OngoingPass = 'OngoingPass',
}

export type Message =
  | { type: MessageType.OngoingOffer; expirationDatetime: string | undefined }
  | { type: MessageType.ExpiredFreeTrial }
  | { type: MessageType.ExpiredPass; productName: string }
  | { type: MessageType.ExpiredSubscription }
  | { type: MessageType.NoOffer };

export type Modal = { type: ModalType; expirationDatetime: string } | null;

export interface OffersMessageAndModalResponse {
  message: Message;
  modal: Modal;
}

// REMOVE USERTYPE => USERCONTEXT
export enum B2bUserType {
  BAM = 'bam',
  TSL = 'tsl',
}

export enum UserContext {
  BKO = 'BKO',
  BAM = 'BAM',
  TSL = 'TSL',
}

// TODO remove UserType in front and backend
export const getUserContext = (b2buserType: B2bUserType): UserContext => {
  const userTypeMap = {
    [UserContext.BAM.toUpperCase()]: UserContext.BAM,
    [UserContext.TSL.toUpperCase()]: UserContext.TSL,
  };
  return userTypeMap[b2buserType.toUpperCase()];
};
